import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ExpenseEditScreen';
import ExpenseEdit from './ExpenseEditScreen';
import { StoreState } from 'src/store/reducers';
import { getExpense } from 'src/store/actions/expense-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        expense: state.expenses.current,
        providers: state.providers.data,
        inProgress: state.expenses.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getExpense(id)),
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const ExpenseEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseEdit);

export default ExpenseEditScreen;
